
.dragger {
  :global {
    .ant-upload.ant-upload-drag {
      border: 1px dashed var(--bc-color-border-secondary);
      border-radius: 8px;
      background-color: var(--bc-color-bg-container);
      padding: 65px 0;

      .ant-upload-drag-container {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }

  svg {
    width: 40px;
    height: 40px;
  }

  .title {
    text-transform: uppercase;
    color: var(--bc-color-text-secondary);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1px;
    margin-bottom: 24px;
    margin-top: 10px;
  }

  .button {
    height: 40px;
    width: 110px;
    color: var(--bc-color-text);
    border: 1px solid var(--bc-color-primary);
    border-radius: 8px;
    text-transform: uppercase;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0.86px;
  }

  .files {
    & > div:not(:last-child) {
      margin-bottom: 10px;
    }
  }
}

.progress {
  position: relative;
  height: 64px;

  .infoContainer {
    z-index: 2;
    width: 100%;
    position: absolute;
    height: 64px;
    display: flex;
    flex-direction: row;
    align-self: center;
    justify-content: space-between;
    left: 0;

    & > * {
      align-self: center;
    }

    .info {
      padding-left: 30px;
    }

    .spinner {
      padding-right: 30px;
    }

    svg {
      width: 25px;
      height: 25px;
    }

    .progressInfo {
      color: var(--bc-color-text-secondary);
      font-size: 12px;
      letter-spacing: 0;
      line-height: 12px;
      margin-top: 10px;
    }

    .nameContainer {
      display: flex;
      align-items: center;
      justify-content: space-between;

      & > *:not(:last-child) {
        margin-right: 10px;
      }
    }

    .name {
      color: var(--bc-color-text);
      font-size: 14px;
      letter-spacing: 0;
      line-height: 14px;
    }
  }

  &.error {
    .progressInfo, .name {
      color: var(--bc-color-text-light-solid);
    }

    svg {
      path:last-child {
        fill: var(--bc-color-text-light-solid);
      }
    }
  }

  :global {
    .ant-progress {
      div {
        height: 64px !important;
      }

      .ant-progress-body {
        border-radius: 8px;
        border: 1px solid var(--bc-color-border-secondary);
        background-color: var(--bc-color-bg-container);
      }

      .ant-progress-track {
        border-radius: 8px;
        background-color: var(--bc-color-primary-bg);
      }

      &.ant-progress-status-exception {
        .ant-progress-track {
          background-color: var(--bc-color-error);
        }

        .ant-progress-body {
          background-color: var(--bc-color-error);
          border: 0;
        }
      }

      &.ant-progress-status-success {
        .ant-progress-track {
          background-color: var(--bc-color-success-bg);
        }

        .ant-progress-body {
          border-radius: 8px;
          border: 0;
          background-color: var(--bc-color-bg-container);
        }
      }
    }
  }
}

.hidden {
  display: none;
}

.otherFilesButton {
  margin-top: 10px;
}

